import { UiState } from 'constants/ui';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getFaqEntryRecordById = (state, id) => localState(state).byId[Number(id)];
export const getFaqEntryRecordByType = (state, type) => localState(state).byType[type];
export const getFaqEntryById = (state, id) => {
  var _getFaqEntryRecordByI;

  return (_getFaqEntryRecordByI = getFaqEntryRecordById(state, id)) === null || _getFaqEntryRecordByI === void 0 ? void 0 : _getFaqEntryRecordByI.entry;
};
export const getFaqEntryByType = (state, type) => {
  var _getFaqEntryRecordByT;

  return (_getFaqEntryRecordByT = getFaqEntryRecordByType(state, type)) === null || _getFaqEntryRecordByT === void 0 ? void 0 : _getFaqEntryRecordByT.entry;
};
export const getFaqEntryStateById = (state, id) => {
  var _getFaqEntryRecordByI2;

  return ((_getFaqEntryRecordByI2 = getFaqEntryRecordById(state, id)) === null || _getFaqEntryRecordByI2 === void 0 ? void 0 : _getFaqEntryRecordByI2.state) || UiState.Idle;
};
export const getFaqEntryStateByType = (state, type) => {
  var _getFaqEntryRecordByT2;

  return ((_getFaqEntryRecordByT2 = getFaqEntryRecordByType(state, type)) === null || _getFaqEntryRecordByT2 === void 0 ? void 0 : _getFaqEntryRecordByT2.state) || UiState.Idle;
};
export const getFaqEntry = id => state => getFaqEntryById(state, id);